import React from 'react';
import { GoogleLogin, useGoogleOAuth } from '@react-oauth/google';

/**
 * Google's sign-in button, with a placeholder holding its spot until it loads.
 *
 * This lives in its own component so that `useGoogleOAuth` -- which throws
 * outside GoogleOAuthProvider -- is only called where a Google button is
 * actually rendered. Called from Auth's top level instead, the rule of hooks
 * would run it on every auth screen, and forgot-password and reset-password
 * would depend on Google without showing a Google button.
 *
 * Nothing about the button itself can be styled: Google draws it in a
 * cross-origin iframe, so `width` and the GIS props are the whole surface.
 */
export default function GoogleAuthButton({ text, width, onSuccess, onError }) {
    // GoogleLogin renders an empty div until Google's script arrives, so this
    // is exactly how long the button's slot stands empty.
    const { scriptLoadedSuccessfully } = useGoogleOAuth();

    return (
        <>
            {!scriptLoadedSuccessfully && (
                <div
                    className="auth-google-skeleton"
                    style={{ width }}
                    data-testid="google-skeleton"
                    aria-hidden="true"
                />
            )}
            <GoogleLogin
                onSuccess={onSuccess}
                onError={onError}
                text={text}
                theme="outline"
                shape="rectangular"
                width={width}
            />
        </>
    );
}
